import httpClient from "@/services/http/mainServerClient";
import { get } from "@/services/http/platformServer";

interface SubmitSurveyData {
    surveyDataList: { question: string; answer: string; additional: string; index: number }[];
    contact?: string;
}

export function submitSurvey(data: SubmitSurveyData) {
    return httpClient.post("/survey_data/submit", data);
}
